import { Autocomplete, Chip, TextField } from "@mui/material"
import { normalizeMacroCategoryList } from "authoring/routes/macro/lib/macro-category-utils"
import Color from "color"
import { getContrastingColor } from "lib/get-contrasting-color"
import uniqolor from "uniqolor"

export function MacroCategorySelector({
    categories = [],
    selectedCategories = [],
    onChange,
    label = "Categories",
    placeholder = "Add category",
    disabled = false,
}) {
    return (
        <Autocomplete
            multiple
            freeSolo
            disableCloseOnSelect
            options={categories}
            value={selectedCategories}
            onChange={handleChange}
            disabled={disabled}
            slotProps={{
                clearIndicator: { "data-cy": "macro-category-clear" },
                listbox: { "data-cy": "macro-category-listbox" },
            }}
            renderTags={renderTags}
            renderInput={renderInput}
        />
    )

    function handleChange(_event, values) {
        if (!onChange) return
        onChange(normalizeMacroCategoryList(values))
    }

    function renderInput(params) {
        return (
            <TextField
                {...params}
                label={label}
                placeholder={placeholder}
                inputProps={{ ...params.inputProps, "data-cy": "macro-category-input" }}
            />
        )
    }
}

function renderTags(values, getTagProps) {
    return values.map(renderTag)

    function renderTag(category, index) {
        const { color } = uniqolor(category, { saturation: [65, 99], lightness: [65, 87] })
        const textColor = getContrastingColor(Color(color).mix(Color("white"), 0.5).hex())
        return (
            <Chip
                {...getTagProps({ index })}
                key={category}
                label={category}
                size="small"
                data-cy="macro-category-chip"
                sx={{ backgroundColor: `${color}80`, color: textColor }}
            />
        )
    }
}
